import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

const navItems = [
  { path: "/", label: "Home" },
  { path: "/#about", label: "About" },
  { path: "#services", label: "Services" },
  { path: "/#portfolio", label: "Portfolio" },
  { path: "/#contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 w-full bg-primary-light/90 backdrop-blur">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-8">
        <Link to="/" className="text-2xl font-heading font-bold text-[#b8860b]">
          MJR&nbsp;Holdings
        </Link>

        {/* Desktop Nav */}
        <div className="hidden gap-8 lg:flex">
          {navItems.map(({ path, label }) => (
            <a
              key={path}
              href={path}
              className="text-[#b8860b] hover:opacity-80 transition font-medium"
            >
              {label}
            </a>
          ))}
        </div>

        {/* Mobile Toggle Button */}
        <button
          className="lg:hidden"
          onClick={() => setOpen((prev) => !prev)}
          aria-label="Toggle navigation menu"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="overflow-hidden bg-primary-light/95 lg:hidden"
          >
            <div className="flex flex-col gap-4 px-6 pb-6 pt-4">
              {navItems.map(({ path, label }) => (
                <a
                  key={path}
                  href={path}
                  onClick={() => setOpen(false)}
                  className="text-[#b8860b] text-lg font-medium hover:opacity-80 transition"
                >
                  {label}
                </a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}
